import { AuthGuard } from './guards/auth-guard.service';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from './guards/profile-guard.service';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'dashboard',
    loadComponent: () => 
    import('./pages/dashboard/dashboard.page').then( m => m.DashboardPage),
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'dashboard',
  //   loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'plant-master',
    loadChildren: () => import('./pages/plant-master/plant-master.module').then( m => m.PlantMasterPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'driver-master',
    loadChildren: () => import('./pages/driver-master/driver-master.module').then( m => m.DriverMasterPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'truck-master',
    loadChildren: () => import('./pages/truck-master/truck-master.module').then( m => m.TruckMasterPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'mapping-master',
    loadChildren: () => import('./pages/mapping-master/mapping-master.module').then( m => m.MappingMasterPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'outbound-trips',
    loadChildren: () => import('./pages/outbound-trips/outbound-trips.module').then( m => m.OutboundTripsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'transporter-master',
    loadChildren: () => import('./pages/transporter-master/transporter-master.module').then( m => m.TransporterMasterPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'epod-pdf',
    loadChildren: () => import('./pages/epod-pdf/epod-pdf.module').then( m => m.EpodPdfPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [ProfileGuard]
  },
  {
    path: 'rcti-statement',
    loadChildren: () => import('./pages/rcti-statement/rcti-statement.module').then( m => m.RctiStatementPageModule)
  },
  {
    path: 'audit-history',
    loadChildren: () => import('./pages/audit-history/audit-history.module').then( m => m.AuditHistoryPageModule)
  },
  {
    path: 'humes-deliveries',
    loadChildren: () => import('./pages/humes-outbound-trips/humes-outbound-trips.module').then( m => m.HumesOutboundTripsModule)
  }
];